// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2jOtu","block":"styles_block__3JXa3","bottomCTA":"styles_bottomCTA__1lL5h","bottomCTAWrapper":"styles_bottomCTAWrapper__2OPYw","cta":"styles_cta__NsLqz"};